export enum WorkspaceType {
  WebApplication = "WebApplication",
  MobileWeb = "MobileWeb",
  AndroidNative = "AndroidNative",
  IOSNative = "IOSNative",
  Rest = "Rest"
}
